module.exports = __webpack_public_path__ + "img/behance.109125d4.svg";